module.exports = __webpack_public_path__ + "static/img-features--mitmachen-558935998c3e56187a9b79ebeeb3f7f5.png";